import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const Container = styled.div`
	margin-bottom: 20px;
`;

const IconWrapper = styled.div`
	width: 48px;
	height: 48px;
	background-color: ${BackgroundColors.BluePrimary};
	border-radius: ${BorderRadius.LG}px;
`;

export { Container, IconWrapper };
